<template>
  <div class="os-layout">
    <onboarding-top-bar></onboarding-top-bar>
    <div class="onboarding-content">
      <onboarding-progress-tracker
        :tabItems="tabItems"
        ref="progressTracker"
        v-if="showTracker"
      />
      <router-view
        :updateStatus="updateStatus"
        :updateTracker="updateTracker"
        :productPackage="productPackage"
        :markAsCompleted="markAsCompleted"
        :getCustomerProductDetails="getCustomerProductDetails"
        :getCustomerEmploymentDetails="getCustomerEmploymentDetails"
      ></router-view>
    </div>
    <div v-if="loSection !== '/onboarding/lo/finish'" class="buttons">
      <onboarding-button
        @onButtonClick="buttonFunction('prev')"
        type="prev"
        text="Back"
      />
      <div class="right-buttons">
        <a
          v-if="loSection == '/onboarding/lo/agreement'"
          class="download-button"
          href="https://solarbase-vue-app.s3.us-west-2.amazonaws.com/Lease To Own Template.docx"
          target="_blank"
          download
        >
          Download Agreement
        </a>
        <onboarding-button
          @onButtonClick="buttonFunction('next')"
          type="next"
          text="Continue"
        />
      </div>
    </div>
  </div>
</template>

<script>
import OnboardingProgressTracker from "../../../OnboardingProgressTracker.vue";
import OnboardingTopBar from "../../../OnboardingTopBar.vue";
import OnboardingButton from "../../../OnboardingButton.vue";
import { mapGetters } from "vuex";

export default {
  name: "LO",
  components: {
    OnboardingTopBar,
    OnboardingButton,
    OnboardingProgressTracker
  },
  computed: {
    ...mapGetters(["getUserSession"]),
    genRandomNumber() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      for (let i = 0; i < 5; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      text += Math.round(new Date().getTime() / 1000);
      return text;
    }
  },
  data() {
    return {
      packageType: {
        name: "",
        productDescription: "",
        amountOS: 0
      },
      productPackage: {},
      employmentPackage: {},
      showTracker: false,
      agreementStatus: false,
      bankStatementPassed: false,
      creditCheckPassed: false,
      kycPassed: false,
      payDepositPassed: false,
      errorMessage: false,
      loSection: "",
      loRoutes: [
        "/onboarding/lo/summary",
        // "/onboarding/lo/job-info",
        "/onboarding/lo/agreement",
        // "/onboarding/lo/bank-statement",
        "/onboarding/lo/credit-check",
        "/onboarding/lo/kyc",
        "/onboarding/lo/deposit",
        "/onboarding/lo/finish"
      ],
      tabItems: [
        {
          title: "Start"
        },
        {
          title: "Payment Summary",
          percent: "16.67",
          path: "/onboarding/lo/summary"
        },
        // {
        //   title: "Job Information",
        //   percent: "27.48",
        //   path: "/onboarding/lo/job-info"
        // },
        {
          title: "Agreement",
          percent: "33.34",
          path: "/onboarding/lo/agreement"
        },
        // {
        //   title: "Bank Statement",
        //   percent: "53",
        //   path: "/onboarding/lo/bank-statement"
        // },
        {
          title: "Credit Check",
          percent: "50.01",
          path: "/onboarding/lo/credit-check"
        },
        {
          title: "KYC",
          percent: "66.68",
          path: "/onboarding/lo/kyc"
        },
        {
          title: "Pay Deposit",
          percent: "83.35",
          path: "/onboarding/lo/deposit"
        },
        {
          title: "Finish",
          percent: "100",
          path: "/onboarding/lo/finish"
        }
      ]
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    buttonFunction(btnType) {
      if (btnType === "prev") {
        switch (this.loSection) {
          case "/onboarding/lo/finish":
            this.showErrorMsg({
              message: "You have successfully completed the onboarding process!"
            });
            break;
          default:
            this.handlePrev();
        }
      } else if (btnType === "next") {
        switch (this.loSection) {
          case "/onboarding/lo/summary":
            // this.processCustomerProduct();
            this.handleNext();
            break;
          case "/onboarding/lo/agreement":
            if (!this.agreementStatus) {
              this.handleNext();
            } else
              this.showErrorMsg({
                message: "Please accept the terms and conditions to continue"
              });
            break;
          // case "/onboarding/lo/bank-statement":
          //   return this.handleNext();
          //   if (this.bankStatementPassed) this.handleNext();
          //   else
          //     this.showErrorMsg({
          //       message: "You have not passed the bank statement check!"
          //     });
          //   break;
          case "/onboarding/lo/credit-check":
            // this.handleNext();
            // return;
            if (this.creditCheckPassed) this.handleNext();
            else
              this.showErrorMsg({
                message: "You need to pass the credit check!"
              });
            break;
          case "/onboarding/lo/kyc":
            if (this.kycPassed) this.handleNext();
            else
              this.showErrorMsg({
                message: "Kindly upload all required details!"
              });
            break;
          case "/onboarding/lo/deposit":
            if (this.payDepositPassed) {
              this.handleNext();
            } else
              this.showErrorMsg({
                message:
                  "You need to pay the initial deposit and setup recurring payment!"
              });
            break;
          case "/onboarding/lo/finish":
            this.showSuccessMsg({
              message:
                "We would call you soon to finalize the documentation and installation process."
            });
            break;
          default:
            this.handleNext();
        }
      }
    },
    handleNext() {
      let pageRouteIndex = this.loRoutes.indexOf(this.$route.path);
      if (pageRouteIndex < this.loRoutes.length) {
        this.$router.push(this.loRoutes[pageRouteIndex + 1]);
        this.loSection = this.loRoutes[pageRouteIndex + 1];
        this.$refs.progressTracker.setActivePoints();
      }
    },
    gotoFinish() {
      this.$router.push("/onboarding/lo/finish");
      this.loSection = "/onboarding/lo/finish";
      this.$refs.progressTracker.setActivePoints();

      // mark completed onboarding
      // this.updateStatus(6);
    },

    handlePrev() {
      let pageRouteIndex = this.loRoutes.indexOf(this.$route.path);
      if (pageRouteIndex > 0) {
        this.$router.push(this.loRoutes[pageRouteIndex - 1]);
        this.loSection = this.loRoutes[pageRouteIndex - 1];
        this.$refs.progressTracker.setActivePoints();
      } else if (pageRouteIndex === 0) this.$router.push("/onboarding");
    },
    getCustomerProductDetails(product) {
      this.productPackage = product;
    },
    getCustomerEmploymentDetails(details) {
      this.employmentPackage = details;
    },
    // processCustomerProduct() {
    //   const HTTP = this.$httpUtils.FASTHTTP;

    //   const data = {
    //     ...this.productPackage,
    //     monthlyIncomeRange: "4",
    //     employmentStatus: "0",
    //     ...this.employmentPackage
    //   };
    //   console.log("now on payment summary >>>>>>>>>>>>>>>>>>>>>>>>>>>>>", data);

    //   HTTP.get(`/productoption/productoption`)
    //     .then(res => {
    //       if (res.data === null) {
    //         HTTP.post(`/productoption/productoption`, data)
    //           .then(response => {
    //             console.log("This is a console logggggg", response.data);
    //             if (response.status) this.handleNext();
    //             else this.showErrorMsg({ message: response.data.message });
    //           })
    //           .catch(error =>
    //             this.showErrorMsg({
    //               message: error.response.data.detail
    //             })
    //           );
    //       } else if (!res.data.isPurchased) {
    //         HTTP.patch(`/productoption/nextproductionoption`, data)
    //           .then(result => {
    //             if (result.status) this.handleNext();
    //             else this.showErrorMsg({ message: result.data.message });
    //           })
    //           .catch(err =>
    //             this.showErrorMsg({ message: err.response.data.detail })
    //           );
    //       }
    //     })
    //     .catch(err => console.log(err));

    // },
    saveCustomerProduct(data) {
      const HTTP = this.$httpUtils.FASTHTTP;

      HTTP.get(`/productoption/productoption`)
        .then(res => {
          if (res.data === null) {
            HTTP.post(`/productoption/productoption`, data)
              .then(response => {
                console.log("This is a console logggggg", response.data);
                if (response.status) this.handleNext();
                else this.showErrorMsg({ message: response.data.message });
              })
              .catch(error =>
                this.showErrorMsg({
                  message: error.response.data.detail
                })
              );
          } else if (!res.data.isPurchased) {
            HTTP.patch(`/productoption/nextproductionoption`, data)
              .then(result => {
                if (result.status) this.handleNext();
                else this.showErrorMsg({ message: result.data.message });
              })
              .catch(err =>
                this.showErrorMsg({ message: err.response.data.detail })
              );
          }
        })
        .catch(err => console.log(err));
    },
    updateStatus(stateid) {
      const HTTP = this.$httpUtils.FASTHTTP;
      const payloadData = {
        stateid: stateid,
        packageType: "LO",
        iscompleted: stateid == 6
      };
      // console.log({ payloadData });

      HTTP.patch("/onboardingstate/nextstate", payloadData, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("appUserToken")}`
        }
      })
        .then(res =>
          this.$store.commit("saveOnboardingCustomerState", res.data)
        )
        .catch(error => console.log({ error }));
    },
    getOnboardingState(id) {
      const HTTP = this.$httpUtils.FASTHTTP;
      HTTP.get(`/onboardingstate/state`)
        .then(response => {
          if (this.$route.path !== this.loRoutes[response.data.stateid - 1]) {
            this.loSection = this.loRoutes[response.data.stateid - 1];
            this.$router.push(this.loRoutes[response.data.stateid - 1]);
          }
        })
        .catch(error => console.log({ error }));
    },
    updateTracker(bool) {
      this.showTracker = bool;
    },
    markAsCompleted(bool) {
      switch (this.loSection) {
        case "/onboarding/lo/agreement":
          this.agreementStatus = bool;
          break;
        case "/onboarding/lo/bank-statement":
          this.bankStatementPassed = bool;
          break;
        case "/onboarding/lo/credit-check":
          this.creditCheckPassed = bool;
          break;
        case "/onboarding/lo/kyc":
          this.kycPassed = bool;
          break;
        case "/onboarding/lo/deposit":
          this.payDepositPassed = bool;
          break;
      }
    }
  },
  mounted() {
    this.getOnboardingState(this.getUserSession.id);
    // this.loSection = this.$route.path;
    this.packageType = this.$store.state.onboardingPackageType;

    if (this.$route.query.goto == "lo_finish") {
      this.gotoFinish();
      this.updateStatus(6);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

.os-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background: #ffffff;
}

.onboarding-content {
  padding: 0px 127px;
  flex: 1;
  overflow-y: scroll;
  box-shadow: 1px 1px 5px #d9d9d9;
}

.buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 127px;
  height: 70px;
}

.buttons,
.right-buttons {
  display: flex;
  align-items: center;
}

.download-button {
  border-radius: 5px;
  padding: 14px 36px;
  text-align: center;
  max-width: 240px;
  background: #fe7a11;
  border: 1px solid #fe7a11;
  color: #ffffff;
  margin-right: 35px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/leaseToOwn/index.vue